module.exports = __webpack_public_path__ + "static/DEV2-87364bf882891252a990c086e920101f.jpg";